import { initializeRuntimeConfig } from '../config/runtimeConfig';
import { renderApp } from './renderApp';
import { resolveHostContext } from './resolveHostContext';

export function bootstrapApp({ rootSelector = '#root', runtimeConfig } = {}) {
  const hostContext = resolveHostContext({ fallbackSelector: rootSelector });
  const resolvedRuntimeConfig = {
    ...hostContext.runtimeConfig,
    ...runtimeConfig
  };

  initializeRuntimeConfig(resolvedRuntimeConfig);

  if (!hostContext.mountElement) {
    throw new Error(`Root element not found: ${rootSelector}`);
  }

  return renderApp(hostContext.mountElement);
}
